import clientAppSetup0 from '/home/radic/projects/@radic-console/node_modules/@vuepress/theme-default/lib/client/clientAppSetup.js'
import clientAppSetup1 from '/home/radic/projects/@radic-console/node_modules/@vuepress/plugin-active-header-links/lib/client/clientAppSetup.js'

export const clientAppSetups = [
  clientAppSetup0,
  clientAppSetup1,
]
